import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Stable per-browser id so free-tier limits can be tracked for signed-out visitors.
export const getDeviceId = () => {
  let id = localStorage.getItem("cv_device_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `d-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("cv_device_id", id);
  }
  return id;
};

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isVisitor = url.startsWith("/visitor") || url.startsWith("/club") || url.startsWith("/payments");
  const token = localStorage.getItem(isVisitor ? "cv_visitor_token" : "cv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Device-Id"] = getDeviceId();
  return config;
});

export default api;
